import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import DeleteModal from '@/components/Modals/DeleteModal';
import CircleMinus from '@/images/CircleMinus.svg';
import { useUpdateCampaign } from '@/pages/campaign/ListPage/api';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import { CampaignAccess, ICampaign } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
interface Props {
    campaign: ICampaign;
    closeMenu: () => void;
}

export const UnPublishMenuItem = ({ campaign, closeMenu }: Props) => {
    const { mutateAsync, isLoading: isDeleting } = useUpdateCampaign(campaign);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const mixpanel = useAnalytics();

    return (
        <>
            <MenuItem
                onClick={async () => {
                    setConfirmationModalOpen(true);
                }}>
                <ListItemIcon>
                    <MaskedIcon src={CircleMinus} size={'24px'} color={theme.colors.secondary.main} />
                </ListItemIcon>
                <ListItemText>{`Unpublish campaign`}</ListItemText>
            </MenuItem>

            <DeleteModal
                itemType="campaign"
                mode="square"
                open={confirmationModalOpen}
                isLoading={isDeleting}
                onDelete={async () => {
                    mixpanel?.track('campaigns-unpublish', { campaign, event: 'confirm' });
                    return mutateAsync({ access: CampaignAccess.PRIVATE });
                }}
                onClose={() => {
                    setConfirmationModalOpen(false);
                    closeMenu();
                }}
                onCancel={() => {
                    mixpanel?.track('campaigns-unpublish', { campaign, event: 'cancel' });
                }}
                text={{
                    title: 'Unpublish Campaign?',
                    content: `Are you sure you want to unpublish "${campaign.title}" \n?All recipients who click on the link in their email will not be able to view the video message`,
                    cta: 'Unpublish',
                }}
                mixpanelProp={{
                    key: 'campaigns-unpublish',
                    properties: {
                        event: 'click',
                        campaign,
                        from: 'menu',
                    },
                }}
            />
        </>
    );
};
